import React, { useEffect } from 'react';

const Privacy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="pt-24 pb-16 min-h-screen bg-remy-dark">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <h1 className="text-4xl font-bold text-white mb-8">Privacy Policy</h1>

                <div className="space-y-6 text-gray-300 leading-relaxed">
                    <p className="text-sm text-gray-500">Last Updated: {new Date().toLocaleDateString()}</p>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">1. Introduction</h2>
                        <p>
                            Welcome to Remy Group. We are committed to protecting your personal information and your right to privacy.
                            If you have any questions or concerns about our policy, or our practices with regards to your personal information,
                            please contact us.
                        </p>
                        <p className="mt-2">
                            This Privacy Policy applies to all of our games, apps, and related services (collectively, our "Services").
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">2. Information We Collect</h2>
                        <p>
                            We collect information that helps us provide you with the best experience possible. This includes:
                        </p>
                        <ul className="list-disc pl-5 mt-2 space-y-2">
                            <li>
                                <strong className="text-white">Device Information:</strong> We may collect information about the device you use to access our Services, including the hardware model, operating system and version, unique device identifiers, and mobile network information.
                            </li>
                            <li>
                                <strong className="text-white">Usage Data:</strong> We collect information about your interactions with our Services, such as the features you use and the time spent on the app.
                            </li>
                            <li>
                                <strong className="text-white">Purchase Information:</strong> If you make purchases within our apps, we process payments through third-party providers (such as Apple App Store or Google Play Store) and do not store your financial details.
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">3. Third-Party Services</h2>
                        <p>
                            We may use third-party services that collect, monitor, and analyze this type of information in order to increase our Services' functionality. These third-party service providers have their own privacy policies addressing how they use such information.
                        </p>
                        <div className="mt-4 p-4 bg-white/5 rounded-lg border border-white/10">
                            <h3 className="text-lg font-medium text-white mb-2">RevenueCat</h3>
                            <p>
                                We use RevenueCat to manage in-app subscriptions and purchases. RevenueCat may collect data related to your purchase history and subscription status to ensure you have access to the premium features you have paid for. This data is handled in accordance with RevenueCat's Privacy Policy.
                            </p>
                        </div>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">4. Data Security</h2>
                        <p>
                            We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">5. Children's Privacy</h2>
                        <p>
                            Our Services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13. If we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">6. Changes to This Privacy Policy</h2>
                        <p>
                            We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">7. Contact Us</h2>
                        <p>
                            If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Privacy;
